var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.goBack}},[_c('SvgIcon',{staticClass:"icon-24",staticStyle:{"width":"42px","height":"42px","cursor":"pointer"},attrs:{"type":"trans"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }